export default __webpack_public_path__ + "static/media/del.aa0d2b2d.svg";